/* eslint-disable */
export default [
    {
        imgSlug: 'cnn-money',
        alt: 'CNN money'
    },
    {
        imgSlug: 'tech-crunch',
        alt: 'TechCrunch'
    },
    {
        imgSlug: 'thenewyorker',
        alt: 'The New York Times'
    },
    {
        imgSlug: 'thrillist',
        alt: 'thrillist'
    },
    {
        imgSlug: 'economist',
        alt: 'The Economist'
    },
    {
        imgSlug: 'mashable',
        alt: 'Mashable'
    },
    {
        imgSlug: 'usa-today',
        alt: 'USA Today'
    },
    {
        imgSlug: 'time',
        alt: 'TIME'
    }
];
